import { Flex, Image, Text } from '@chakra-ui/react'
import { useSignInWithGoogle } from 'react-firebase-hooks/auth'
import useShowToast from '../../hooks/useShowToast';
import useAuthStore from '../../store/authStore';
import { auth, firestore } from '../../firebase/firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const GoogleAuth = ({ isLogin }) => {
    const [signInWithGoogle, error] = useSignInWithGoogle(auth);
    const showToast = useShowToast();
    const loginUser = useAuthStore((state) => state.login);
    const handleGoogleAuth = async () => {
        try{
            const newUser = await signInWithGoogle();
            if (!newUser && error){
                showToast('error', error.message, "error");
                return;
            }
            
            const userRef = doc(firestore, "users", newUser.user.uid);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
                // login
                const userDoc = userSnap.data();
                console.log("Existing userDoc:", userDoc);
                localStorage.setItem("user-info", JSON.stringify(userDoc));
                loginUser(userDoc);
            }
            else{
                // signup
                const userDoc = {
                    uid: newUser.user.uid,
                    email: newUser.user.email,
                    username: newUser.user.email.split("@")[0],
                    fullName: newUser.user.displayName,
                    profilePicURL: newUser.user.photoURL,
                    followers:[],
                    following:[],
                    posts:[],
                    bio:"",
                    createdAt: Date.now()
                };
                console.log("New userDoc:", userDoc);
                await setDoc(doc(firestore, "users", newUser.user.uid), userDoc);
                localStorage.setItem("user-info", JSON.stringify(userDoc));
                loginUser(userDoc);
            }
        } catch(error){
            showToast('error', error.message, "error");
        }
    }

  return (
    <Flex alignItems={"center"} justifyContent={"center"} cursor={"pointer"} onClick={handleGoogleAuth}>
        <Image src="/google.png" w={5} alt="Google logo" />
        <Text mx={2} color={"blue.500"}>
            {isLogin ? "Log in with Google" : "Sign up with Google"}
        </Text>
    </Flex>
  )
}

export default GoogleAuth
